import { type ReactNode } from "react";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";

interface LegalLayoutProps {
  title: string;
  metaTitle?: string;
  metaDescription?: string;
  canonicalPath?: string;
  children: ReactNode;
}

export default function LegalLayout({
  title,
  metaTitle,
  metaDescription,
  canonicalPath,
  children,
}: LegalLayoutProps) {
  const seoTitle = metaTitle || `${title} | Zweering Elektrotechnik Emmerich am Rhein`;
  const seoDesc =
    metaDescription || `${title} der Zweering Elektrotechnik GmbH in Emmerich am Rhein.`;
  const canonical = `https://zweering.de${canonicalPath ?? "/"}`;

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "Archivo, sans-serif" }}>
      <Seo
        title={seoTitle}
        description={seoDesc}
        canonical={canonical}
        breadcrumbs={[
          { name: "Startseite", url: "https://zweering.de/" },
          { name: title, url: canonical },
        ]}
      />
      <Header />
      <main id="main-content" className="px-6 md:px-10 lg:px-14 pt-40 pb-32">
        <div className="max-w-[720px] mx-auto">
          <p className="text-[#4CAF50] uppercase text-xs md:text-sm tracking-widest mb-4 font-medium">
            Rechtliches
          </p>
          <h1
            className="font-bold uppercase text-[#0A0A0A] text-[26px] sm:text-[36px] md:text-[52px] leading-[0.95] mb-12"
            style={{ letterSpacing: "-1.6px" }}
          >
            {title}
          </h1>
          <div className="legal-content text-foreground-700 text-base leading-relaxed space-y-6">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
